import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/payment-create-screen.module.scss';

import Form from '../../components/PaymentForm';
import { QueryParams } from 'src/types/grid';
import { Paginated } from 'src/services/api-handlers/pagination';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IServiceType } from 'src/types/service-types';
import { IInvoice } from 'src/types/invoice';
import { PaymentFormData } from '../../components/PaymentForm';
import { RouteComponentProps } from 'react-router';
import { toast } from 'react-toastify';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    students: SelectObject[];
    vendors: SelectObject[];
    districts: SelectObject[];
    providers: SelectObject[];
    serviceTypes: Paginated<IServiceType>;
    invoices: Paginated<IInvoice>;
    valuesForm: Partial<PaymentFormData>;
    caseNumbers: { [key: string]: string | null }[];
}

export interface DispatchProps {
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getInvoices: (params: QueryParams) => void;
    getCaseNumbers: () => void;
}

export interface OwnProps extends RouteComponentProps {
    history: any;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const PaymentCreateScreen: React.FunctionComponent<Props> = (props) => {
    const {
        getStudents,
        getDistricts,
        getVendors,
        getServiceTypes,
        getProviders,

        invoices,
        getInvoices,
        students,
        vendors,
        districts,
        providers,
        serviceTypes,
        valuesForm,
        caseNumbers,
        getCaseNumbers,
        history,
    } = props;
    const caseTypeHistory: any = history?.location?.state?.caseType
        ? history.location.state.caseType
        : { label: 'DOE', value: 1 };

    let amount: any = 0;
    let paymentCredits: any = [];
    if (valuesForm) {
        amount = valuesForm.amount ? valuesForm.amount : 0;
        paymentCredits = valuesForm.paymentCredits ? valuesForm.paymentCredits : [];
    }

    let stateAmount = 0;
    let amountCredits = 0;
    const [stateData, setStateData] = useState<any>({});
    Object.keys(stateData).forEach((k: any) => {
        stateAmount += stateData[k].remainingAmount ? +stateData[k].remainingAmount : 0;
    });

    paymentCredits.forEach((it: any) => {
        amountCredits += it.amount ? +it.amount : 0;
    });
    const totalAmount: number = +amountCredits + +stateAmount;
    const remainAmount: number = +(+amount - +totalAmount).toFixed(2);

    useEffect(() => {
        getStudents({
            page: 1,
            itemsPerPage: 9000,
        });
        getStudents({
            page: 1,
            itemsPerPage: 9000,
        });
        getProviders({
            page: 1,
            itemsPerPage: 1200,
        });

        getCaseNumbers();

        getDistricts({
            page: 1,
            itemsPerPage: 9000,
        });
        getVendors({
            page: 1,
            itemsPerPage: 9000,
        });

        getServiceTypes({
            page: 1,
            itemsPerPage: 9000,
        });
        // eslint-disable-next-line
    }, [getVendors, getServiceTypes, getDistricts, getStudents]);

    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        if (+remainAmount === 0) {
            handleSubmit(e);
        } else {
            toast.error('Remaining amount needs to be 0!');
            return false;
        }
    };

    const handleDraftSub = (handleSubmit: (e: any) => void, e: any) => {
        handleSubmit(e);
    };

    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'PAYMENTS', path: routes.PAYMENTS_LIST },
                    { name: `ADD NEW`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                <Form
                    caseTypeHistory={caseTypeHistory}
                    students={students}
                    handleSub={handleSub}
                    handleDraftSub={handleDraftSub}
                    vendors={vendors}
                    getData={getInvoices}
                    providers={providers}
                    invoices={invoices}
                    districts={districts}
                    stateData={stateData}
                    caseNumbers={caseNumbers}
                    changeValue={(field, value) => false}
                    amountValue={amount}
                    setStateData={setStateData}
                    serviceTypes={serviceTypes}
                    initialValues={{ caseType: caseTypeHistory }}
                    remainAmount={remainAmount}
                    totalAmount={totalAmount}
                />
            </div>
        </RoleLayout>
    );
};

export default PaymentCreateScreen;
